import React, { Component } from "react";
import { Icon } from "antd";
import OptionsBox from "../OptionsBox";
import "./Navbar.scss";

import { ReactComponent as CloseSvg } from "../../assets/icon/ic_close_24dp.svg";
import { ReactComponent as AddSvg } from "../../assets/icon/ic_add_24dp.svg";
import { ReactComponent as SettingsSvg } from "../../assets/icon/ic_settings_24dp.svg";
import { ReactComponent as ArrowBack } from "../../assets/icon/ic_arrow_back_24dp.svg";

function GetNavbarButtons({
  settingsOpen,
  openMessageBox,
  toggleMoreOptions,
  onOptionsClickAway,
  isIconActive,
  toggleOptionsBox,
  optionsBoxOpen,
  optionBoxDirection,
  collapsed,
  isMinimalist,
}) {
  if (isMinimalist && collapsed) {
    return false;
  }
  if (settingsOpen) {
    return (
      <div className="header-buttons">
        <Icon
          className="action-button"
          component={CloseSvg}
          onClick={(e) => {
            e.stopPropagation();
            toggleMoreOptions();
          }}
        />
      </div>
    );
  }
  return (
    <div className="header-buttons">
      <Icon
        className="action-button"
        component={AddSvg}
        onClick={openMessageBox}
      />
      <Icon
        className={"action-button " + isIconActive}
        component={SettingsSvg}
        onClick={toggleOptionsBox}
      />
      {optionsBoxOpen && (
        <OptionsBox
          onClickAway={onOptionsClickAway}
          toggleMoreOptions={toggleMoreOptions}
          direction={optionBoxDirection}
        />
      )}
      <Icon
        className="action-button"
        component={CloseSvg}
        onClick={collapsed}
      />
    </div>
  );
}

class Navbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      optionsBoxOpen: false,
      optionBoxDirection: "bottom",
    };
    this.onOptionsClickAway = this.onOptionsClickAway.bind(this);
  }

  onOptionsClickAway() {
    this.setState({
      optionsBoxOpen: false,
    });
  }

  openMessageBox(e) {
    e.stopPropagation();
    this.props.openMessageBox({
      newChat: true,
    });
  }

  toggleOptionsBox(e) {
    e.stopPropagation();
    this.props.loadedConfigurations &&
      this.setState({
        optionsBoxOpen: !this.state.optionsBoxOpen,
        optionBoxDirection: this.props.parentCollapsed ? "top" : "bottom",
      });
  }

  isIconActive() {
    return this.state.optionsBoxOpen ? "active" : "";
  }

  getTitleClasses() {
    return this.props.status ? "title" : "title title-only";
  }

  toggleMoreOptions() {
    this.setState(
      {
        optionsBoxOpen: false,
      },
      this.props.toggleMoreOptions()
    );
  }

  render() {
    const themeConfig = window.Social.getThemeConfig();

    const {
      notify,
      parentCollapsed,
      settingsOpen,
      onNavbarClick,
      title,
      status,
    } = this.props;

    const minimalistTheme =
      themeConfig && themeConfig.minimalist ? "minimalist" : "";

    return (
      <div
        className={`navbar ${notify ? "notify" : ""} ${minimalistTheme} ${
          parentCollapsed ? "collapsed" : ""
        }`}
        onClick={onNavbarClick}
      >
        <div className="header">
          <ArrowBack className="arrow-back-icon" />

          {themeConfig && themeConfig.minimalist && parentCollapsed && (
            <div className="add-chat-container">
              <Icon
                className="action-button-square add-chat"
                component={AddSvg}
                onClick={this.openMessageBox.bind(this)}
              />
            </div>
          )}

          <div className="header-title">
            <span className={this.getTitleClasses()}>{title}</span>
            {status && <span className="status">{status}</span>}
          </div>

          <GetNavbarButtons
            collapsed={parentCollapsed}
            settingsOpen={settingsOpen}
            isMinimalist={themeConfig && themeConfig.minimalist}
            openMessageBox={this.openMessageBox.bind(this)}
            toggleMoreOptions={this.toggleMoreOptions.bind(this)}
            onOptionsClickAway={this.onOptionsClickAway}
            isIconActive={this.isIconActive()}
            toggleOptionsBox={this.toggleOptionsBox.bind(this)}
            optionsBoxOpen={this.state.optionsBoxOpen}
            loadedConfigurations={this.state.loadedConfigurations}
            optionBoxDirection={this.state.optionBoxDirection}
          />
        </div>
      </div>
    );
  }
}

export default Navbar;
